<template>
	<b-container class="py-5 my-5">
		<h2 class="mb-4 mb-lg-5 text-center">Export Report</h2>
		<b-card class="form form-lg mx-auto">
			<a @click.prevent="$router.go(-1)" class="mb-3 d-inline-block" href>
				<b-icon icon="chevron-left"></b-icon> Return
			</a>
			<FormExportParameters :powerbi-report-id="powerbiReportID" />
		</b-card>
	</b-container>
</template>

<script>
import ExportParameters from "@components/FormExportParameters";

export default {
	inject: ["reportSvc"],
	components: {
		[ExportParameters.name]: ExportParameters,
	},
	data() {
		return {
			report: undefined,
		};
	},
	computed: {
		powerbiReportID() {
			return this.report ? this.report.reportConfig[0].reportId : "";
		},
	},
	methods: {
		async getReport() {
			const rs = await this.reportSvc.read(
				{
					id: this.$route.params.id,
				},
				this.$route.query.company
					? { company_id: parseInt(this.$route.query.company) }
					: null
			);

			this.report = JSON.parse(rs.data.data.data);
		},
	},
	mounted() {
		this.getReport();
	},
};
</script>
